<template>
  <div class="inforList">
    <div class="content">
      <van-search
        v-model="listNameLike"
        placeholder="请输入关键词"
        @input="listLike"
      />
      <div class="tongzhiList">
        <div class="inList">
          <div class="tongzhiIcon">
            <img src="../assets/images/fuwu.png" alt="" />
          </div>
          <div class="rightContent">
            <div class="topContent">
              <div class="tongzhiName">应用消息</div>
              <div class="date">2021-04-22</div>
            </div>
            <div class="botContent">
              <div class="tongzhiContent">扫码乘车扣款通知</div>
              <div class="tongzhiNum">1</div>
            </div>
          </div>
        </div>
        <div class="inList">
          <div class="tongzhiIcon">
            <img src="../assets/images/fuwu.png" alt="" />
          </div>
          <div class="rightContent">
            <div class="topContent">
              <div class="tongzhiName">服务通知</div>
              <div class="date">2021-04-22</div>
            </div>
            <div class="botContent">
              <div class="tongzhiContent">系统更新公告</div>
              <div class="tongzhiNum">1</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import Vue from "vue";
import { Search } from "vant";
import { DropdownMenu, DropdownItem } from "vant";
import { List } from "vant";

import { Icon } from "vant";
import { Dialog } from "vant";
Vue.use(Icon);

Vue.use(List);

Vue.use(DropdownMenu);
Vue.use(DropdownItem);

Vue.use(Search);
export default {
  mounted() {

  
  },
  data() {
    return {
      listNameLike: "",
    };
  },
  methods: {
    listLike() {
      console.log(1);
    },
    getToken() {
      let token = this.$route.query.token;
      localStorage.setItem("token", token);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #eaeaea;
  font-size: 1.875rem;
  color: #19212a;
  position: fixed;
  background-color: #ffffff;
  top: 0;
  left: 0;
  z-index: 1000;

  .zuojian {
    position: absolute;
    top: 0;
    left: 2.125rem;
  }
}
.content ::v-deep .van-search {
  width: 42.875rem;
  height: 5rem;
  background: #ffffff;
  padding: 0;
  border-radius: 2.5rem;
  .van-search__content {
    border-radius: 2.5rem;
    padding-left: 2.625rem;
    background: #ffffff;

    .van-cell {
      padding: 0;

      .van-cell__value--alone .van-field__body .van-field__control {
        font-size: 1.75rem;
        color: #878787;
        margin-left: 0.625rem;
      }

      .van-field__left-icon .van-icon {
        font-size: 2.5rem;
        color: #878787;
      }
    }
  }
}
.content {
  background-color: #eef4f6;
  padding: 1.875rem 2rem;
  height: 100vh;

  .tongzhiList {
    background: #ffffff;
    margin-top: 1.875rem;
    border-radius: 1rem;
    padding: 2.625rem 2rem 0 2rem;
  }
  .inList {
    display: flex;
    margin-bottom: 2.5rem;
    padding-bottom: 2.875rem;
    border-bottom: 1px solid #eaeaea;
    img {
      width: 4.75rem;
    }
    .rightContent {
      width: 100%;

      margin-left: 1.75rem;

      .topContent {
        display: flex;
        justify-content: space-between;
        .tongzhiName {
          color: #19212a;
          font-size: 1.875rem;
        }
        .date {
          color: #878787;
          font-size: 1.5rem;
        }
      }
      .botContent {
        display: flex;
        justify-content: space-between;
        margin-top: 0.625rem;
        .tongzhiContent {
          color: #878787;
          font-size: 1.625rem;
        }
        .tongzhiNum {
          width: 2.125rem;
          height: 2.125rem;
          text-align: center;
          background: #ff3217;
          color: #fff;
          border-radius: 100px;
        }
      }
    }
  }
}
</style>